module.exports = __webpack_public_path__ + "img/rank-1.4ce524d0.svg";